import Icon, { BaseProps } from './base';

type CreateIconProps = {
  path: React.ReactElement;
};

function createIcon({ path }: CreateIconProps) {
  return (props: BaseProps) => <Icon {...props}>{path}</Icon>;
}

export default createIcon;
